/**
 * Pave numerique de l'ecran de vente (quantite, rabais, prix) : grosses
 * touches tactiles (design 1 et 4.3), et le clavier marche aussi (chiffres,
 * virgule ou point, Retour arriere, Entree).
 */
import { useLayoutEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import BackspaceOutlinedIcon from '@mui/icons-material/BackspaceOutlined';
import { palette } from '../app/theme';

const TOUCHE_SX = {
    minWidth: 88, height: 72, fontSize: 30, fontWeight: 800, borderRadius: 2,
    color: palette.text, borderColor: palette.border, bgcolor: palette.surface,
};

/**
 * @param {object} props
 * @param {string} props.valeur texte saisi
 * @param {(v: string) => void} props.onChange
 * @param {() => void} props.onValider Entree
 * @param {boolean} [props.decimale] touche virgule (montants, pourcentages)
 * @param {number} [props.longueurMax]
 */
export default function PaveSaisie({ valeur, onChange, onValider, decimale = false, longueurMax = 10 }) {
    const etat = useRef({ valeur, onChange, onValider });
    etat.current = { valeur, onChange, onValider };

    const ajouter = (c) => {
        const v = etat.current.valeur;
        if (v.length >= longueurMax) return;
        if (c === ',' && (!decimale || v.includes(','))) return;
        etat.current.onChange(v + c);
    };

    // useLayoutEffect : l'ecoute est en place des l'ouverture du dialogue, avant
    // la touche suivante (un useEffect pourrait arriver apres elle).
    useLayoutEffect(() => {
        const ecoute = (event) => {
            if (event.ctrlKey || event.metaKey || event.altKey) return;
            if (/^[0-9]$/.test(event.key)) {
                event.preventDefault();
                ajouter(event.key);
            } else if (event.key === ',' || event.key === '.') {
                event.preventDefault();
                ajouter(',');
            } else if (event.key === 'Backspace') {
                event.preventDefault();
                etat.current.onChange(etat.current.valeur.slice(0, -1));
            } else if (event.key === 'Enter') {
                event.preventDefault();
                etat.current.onValider();
            }
        };
        window.addEventListener('keydown', ecoute);
        return () => window.removeEventListener('keydown', ecoute);
    }, []);

    const touche = (c) => (
        <Button key={c} variant="outlined" onClick={() => ajouter(c)} sx={TOUCHE_SX}>{c}</Button>
    );
    return (
        <Box role="group" aria-label="Pavé de saisie" sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 88px)', gap: '12px' }}>
            {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map(touche)}
            {decimale ? touche(',') : <Box />}
            {touche('0')}
            <Button variant="outlined" aria-label="Effacer" onClick={() => onChange(valeur.slice(0, -1))} sx={TOUCHE_SX}>
                <BackspaceOutlinedIcon sx={{ fontSize: 30 }} />
            </Button>
        </Box>
    );
}
